<template>
    <div class="column is-four-fifths" v-if="initDone">
        <template v-if="receivers.length > 0">
            <div>{{ translate("notification_center.review_receivers_table") }}</div>
            <div class="table-container mt-3">
                <table class="table is-hoverable is-fullwidth">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>{{ translate("common.first_name_and_last_name") }}</th>
                            <th>{{ translate("common.email") }}</th>
                            <th>{{ translate("common.phone") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="receiver in receivers" :key="receiver.id">
                            <td>{{ receiver.id }}</td>
                            <td class="clarity-mask">{{ receiver.firstName }} {{ receiver.lastName }}</td>
                            <td class="clarity-mask">
                                {{ receiver.email }}
                            </td>
                            <td class="clarity-mask">
                                {{ receiver.phone }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="buttons">
                    <button @click="previousPage" class="button">
                        <span class="icon"> <i class="fas fa-angle-double-left" /></span>
                        <span>{{ translate("admin_payments.previous_page") }}</span>
                    </button>
                    <button @click="nextPage" class="button">
                        <span>{{ translate("admin_payments.next_page") }}</span>
                        <span class="icon">
                            <i class="fas fa-angle-double-right" />
                        </span>
                    </button>
                </div>
            </div>
        </template>
        <Notification v-else class="is-info has-text-centered">
            <span class="icon">
                <i class="fas fa-info-circle"></i>
            </span>
            <span>{{ translate("notification_center.no_receivers_for_criteria") }}</span>
        </Notification>
    </div>
    <div v-else class="column is-four-fifths">
        <div class="columns is-centered">
            <LoadingSpinner2 class="has-added-margin" />
        </div>
    </div>
</template>

<script>
    import apiMixin from "../../Api/apiMixin";
    import { mapState } from "vuex";
    import LoadingSpinner2 from "../../Common/LoadingSpinner2";
    import toastMixin from "../../Common/toastMixin";
    import Notification from "../../Common/Notification";
    import translatorMixin from "../../Common/translatorMixin";
    import errorHandlerMixin from "../../Common/errorHandlerMixin";
    import { PAGE_CURSOR_ASC, PAGE_CURSOR_DESC } from "../createNotification";

    const LIMIT = 25;

    export default {
        name: "review-receivers-step",
        components: { Notification, LoadingSpinner2 },
        mixins: [apiMixin, toastMixin, translatorMixin, errorHandlerMixin],
        data() {
            return {
                initDone: false,
                receivers: [],
            };
        },
        computed: {
            ...mapState("filteringReceivers", ["selectedCountries", "paymentStatus"]),
            ...mapState("choosingSourceEvents", ["selectedEvents"]),
        },
        mounted() {
            return this.loadPage(0, PAGE_CURSOR_ASC).then(() => {
                this.initDone = true;
            });
        },
        methods: {
            loadPage(cursor, direction) {
                if (this.selectedEvents.length === 0) {
                    return Promise.resolve();
                }

                return this.notificationsCenterApi()
                    .getSearchResults(this.selectedEvents, this.selectedCountries, this.paymentStatus, {
                        limit: LIMIT,
                        cursor: cursor,
                        direction: direction,
                    })
                    .then(receivers => {
                        if (receivers.length === 0 && this.receivers.length > 0) {
                            this.errorToast(this.translate("common.no_results"));
                            return;
                        }

                        this.receivers = receivers;
                    })
                    .catch(this.handleError);
            },
            nextPage() {
                if (this.receivers.length === 0) {
                    return;
                }

                const lastReceiver = this.receivers[this.receivers.length - 1];

                return this.loadPage(lastReceiver.id, PAGE_CURSOR_ASC);
            },
            previousPage() {
                if (this.receivers.length === 0) {
                    return;
                }

                const firstReceiver = this.receivers[0];

                return this.loadPage(firstReceiver.id, PAGE_CURSOR_DESC);
            },
        },
    };
</script>

<style scoped></style>
